import React, { useEffect, useState } from "react";
import tea from "../assets/articale/8.jpg";

const GetYourHands = () => {
  const [vid, setVid] = useState(null);

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc && window?.clickmagick_cmc?.vid) {
        setVid(window?.clickmagick_cmc?.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        {"How Can You Get Herbal Tea Therapy’s “Breathe”?"}
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={tea}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p>
          <span className="font-bold">
            {" Simply click the big blue button labeled"}
          </span>{" "}
          {vid ? (
            <a
              id="cta-button"
              href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
              rel="noopener noreferrer"
            >
              <span
                className="font-bold text-blue-600 hover:underline bg-[#ffbf00]"
                title="GET Herbal Tea Therapy Breathe NOW"
              >
                {"“GET 40% OFF ‘Breathe’ Now!”"}
              </span>
            </a>
          ) : (
            <a
              id="cta-button"
              href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
              rel="noopener noreferrer"
            >
              <span
                className="font-bold text-blue-600 hover:underline bg-[#ffbf00]"
                title="GET Herbal Tea Therapy Breathe NOW"
              >
                {"“GET 40% OFF ‘Breathe’ Now!”"}
              </span>
            </a>
          )}{" "}
          
          {"You’ll land on our secure page, where your "}
          <span className="font-bold">
            {" discount is automatically applied."}
          </span>
        </p>

        <p>
          {
            "Just fill in your details (name, address, payment info) and pick the offer you’d like."
          }
        </p>

        <p>
          <span className=" bg-[#ffbf00] font-bold">
            {" "}
            {"Why Do Most People Choose 3 or 6 Bottles?"}
          </span>
        </p>
        <p>
          <span className=" bg-[#ffbf00] font-bold">
            {" They don’t want to miss out"}
          </span>{" "}
          {"on “Breathe” when it sells out—it’s that popular."}
        </p>
        <p>
          <span className=" bg-[#ffbf00] font-bold">
            {" They see it as a long-term investment"}
          </span>{" "}
          {"for stronger, healthier lungs."}
        </p>
        <p>
          <span className="font-bold">{"They save more money "}</span>
          {"thanks to reduced shipping costs that we pass on to you.."}
        </p>
        <p>
          {
            " So if you know a friend, family member, or co-worker who struggles with mucus and breathlessness—or if you simply want a few bottles for your home, car, or office "
          }{" "}
          <span className="bg-[#ffbf00] font-bold">{"now"}</span>{" "}
          {"is the best time to grab your supply at our lowest price ever."}
        </p>
        <div className="flex justify-center my-5">
          <div className="flex justify-center my-5">
            {vid ? (
              <a
                id="cta-button"
                href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
                rel="noopener noreferrer"
              >
                {/* a  */}
                <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
                  <span className="text-lg font-semibold">
                    {"GET 40% OFF Breathe"}
                  </span>
                  <span className="text-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                    </svg>
                  </span>
                </button>
              </a>
            ) : (
              <a
                id="cta-button"
                href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
                rel="noopener noreferrer"
              >
                <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
                  <span className="text-lg font-semibold">
                    {"GET 40% OFF Breathe"}
                  </span>
                  <span className="text-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                    </svg>
                  </span>
                </button>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetYourHands;
